import { openErrorToast } from '@pct/ng-feature-message';
import type { CappusError } from '../error/cappus-error';
import type { CappusErrorHandler } from '../cappus-error-handler';
import { getValidErrorKey } from '../error/get-valid-error-key';
import { isNil } from '@pct/ts-typeguard';

export class UniversalErrorHandler implements CappusErrorHandler {
  canHandle(): boolean {
    return true;
  }

  handle(error: CappusError): Promise<void> {
    if (isNil(error?.errors) || error.errors.length < 1) {
      openErrorToast({ message: 'API_ERRORS.UNKNOWN_ERROR' });
      return Promise.resolve();
    }

    error.errors.forEach(({ strId }) => {
      openErrorToast({ message: `API_ERRORS.${getValidErrorKey(strId)}` });
    });
    return Promise.resolve();
  }
}
